import { render, staticRenderFns } from "./FormItemSelect.vue?vue&type=template&id=721016ca"
import script from "./FormItemSelect.vue?vue&type=script&lang=ts"
export * from "./FormItemSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports